import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function CancelFailed({ onClose }: ModalProps) {
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>예약 취소 실패</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>예약 취소를 실패했습니다. 다시 시도해주세요.</S.Summary>
        </S.ModalContent>
        <S.CloseButton type="button" onClick={onClose}>
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
